import axios from "axios";

const isProduction = process.env.REACT_APP_IS_PRODUCTION === "true";
const API_BASE_URL = isProduction
  ? process.env.REACT_APP_API_ENDPOINT
  : process.env.REACT_APP_UAT_API_ENDPOINT;

const GetShowPriceSettingAPI = async (businessName) => {
  const encodedBusinessName = encodeURIComponent(businessName || "");
  const endpoint = `${API_BASE_URL}/settings/show-price?businessName=${encodedBusinessName}`;
  const res = await axios.get(endpoint);
  return res.data;
};

export { GetShowPriceSettingAPI };
